import { useSalesHistoryOfferAuction } from 'pages/Seller/VehicleSalesHistory/hooks';

export const useCounterAmount = (vehicle: any): number | null => {
  const offerAuction = useSalesHistoryOfferAuction(vehicle.id);

  if (vehicle.active_alternative_offer) {
    return vehicle.active_alternative_offer.amount;
  }

  const lastOffer = offerAuction?.privateOffers?.find((offer: any) => offer.sender?.role !== 'buyer');
  return lastOffer?.amount ?? null;
};

export const useLastOfferAmount = (vehicle: any): number | null => {
  const offerAuction = useSalesHistoryOfferAuction(vehicle.id);

  if (vehicle.top_alternative_bid_offer) {
    return vehicle.top_alternative_bid_offer.amount;
  }

  const lastOffer = offerAuction?.offerBids?.[0];
  if (lastOffer) {
    return lastOffer?.amount;
  }

  const lastBid = vehicle.bids?.[0];
  return lastBid?.amount || null;
};
